import React, { FunctionComponent } from 'react';

const Content: FunctionComponent = () => <div>Caterers</div>;

export default Content;
